import { render, staticRenderFns } from "./AlertNameTop.vue?vue&type=template&id=384980ec&scoped=true"
import script from "./AlertNameTop.vue?vue&type=script&lang=js"
export * from "./AlertNameTop.vue?vue&type=script&lang=js"
import style0 from "./AlertNameTop.vue?vue&type=style&index=0&id=384980ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384980ec",
  null
  
)

export default component.exports